import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, vModelText as _vModelText, withDirectives as _withDirectives, vModelDynamic as _vModelDynamic, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-524d324a"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "page-reset_password com_bg1" }
const _hoisted_2 = { id: "wrapper1" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: "/WITH_AG_PORTAL/images/with-kaunet_logo2.png",
  alt: "ウィズカウネット エージェントポータル",
  class: "with-kaunet_logo2"
}, null, -1))
const _hoisted_4 = {
  key: 0,
  class: "com_form_contet1"
}
const _hoisted_5 = { class: "inner1" }
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h2", { class: "title1" }, "パスワード変更", -1))
const _hoisted_7 = { class: "error-message" }
const _hoisted_8 = { class: "com_center1 com_mgt40" }
const _hoisted_9 = {
  key: 1,
  class: "com_form_contet1"
}
const _hoisted_10 = {
  key: 0,
  class: "inner1"
}
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h2", { class: "title1 com_mgb60" }, "パスワード変更完了", -1))
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "com_center1 com_mgb30" }, "パスワードの変更が完了しました。", -1))
const _hoisted_13 = {
  key: 1,
  class: "inner1"
}
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h2", { class: "title1" }, "パスワード変更", -1))
const _hoisted_15 = { class: "form1" }
const _hoisted_16 = { class: "group1" }
const _hoisted_17 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { for: "loginId" }, "ログインID", -1))
const _hoisted_18 = { class: "group1" }
const _hoisted_19 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { for: "newPassword" }, "新しいパスワード", -1))
const _hoisted_20 = { class: "ch_input_password1" }
const _hoisted_21 = ["type"]
const _hoisted_22 = ["src"]
const _hoisted_23 = { class: "group1" }
const _hoisted_24 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { for: "newPasswordConfirm" }, "パスワード確認", -1))
const _hoisted_25 = { class: "ch_input_password1" }
const _hoisted_26 = ["type"]
const _hoisted_27 = ["src"]
const _hoisted_28 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "com_fs14 com_mgt20" }, [
  /*#__PURE__*/_createTextVNode(" パスワードは半角英数14文字以上20文字以内で、"),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createTextVNode(" 大文字・小文字・数字・記号（#-@_.）をすべて含めてください。 ")
], -1))
const _hoisted_29 = {
  key: 0,
  class: "error-message-2"
}
const _hoisted_30 = ["disabled"]
const _hoisted_31 = { class: "com_center1" }
const _hoisted_32 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "com_copyright1" }, "© 2025 Kaunet", -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _hoisted_3,
      (_ctx.isError)
        ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
            _createElementVNode("div", _hoisted_5, [
              _hoisted_6,
              _createElementVNode("div", _hoisted_7, [
                _createElementVNode("p", _hoisted_8, _toDisplayString(_ctx.errorMessage), 1)
              ])
            ])
          ]))
        : (_openBlock(), _createElementBlock("div", _hoisted_9, [
            (_ctx.isSuccessUpdate)
              ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
                  _hoisted_11,
                  _hoisted_12,
                  _createVNode(_component_router_link, {
                    to: "/login",
                    class: "com_button1 com_mgb50"
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode("ログインページ")
                    ]),
                    _: 1
                  })
                ]))
              : (_openBlock(), _createElementBlock("div", _hoisted_13, [
                  _hoisted_14,
                  _createElementVNode("div", _hoisted_15, [
                    _createElementVNode("div", _hoisted_16, [
                      _hoisted_17,
                      _withDirectives(_createElementVNode("input", {
                        type: "text",
                        id: "loginId",
                        readonly: "",
                        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.loginId) = $event))
                      }, null, 512), [
                        [_vModelText, _ctx.loginId]
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_18, [
                      _hoisted_19,
                      _createElementVNode("div", _hoisted_20, [
                        _withDirectives(_createElementVNode("input", {
                          type: _ctx.isPasswordVisible ? 'text' : 'password',
                          id: "newPassword",
                          "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.password) = $event)),
                          maxlength: "20"
                        }, null, 8, _hoisted_21), [
                          [_vModelDynamic, _ctx.password]
                        ]),
                        _createElementVNode("span", {
                          class: "toggle_icon1",
                          onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.togglePasswordVisibility('password')))
                        }, [
                          _createElementVNode("img", {
                            class: "pwdIcon",
                            src: _ctx.currentPassworIcon
                          }, null, 8, _hoisted_22)
                        ])
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_23, [
                      _hoisted_24,
                      _createElementVNode("div", _hoisted_25, [
                        _withDirectives(_createElementVNode("input", {
                          type: _ctx.isConfirmPasswordVisible ? 'text' : 'password',
                          id: "newPasswordConfirm",
                          "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.confirmPassword) = $event)),
                          maxlength: "20"
                        }, null, 8, _hoisted_26), [
                          [_vModelDynamic, _ctx.confirmPassword]
                        ]),
                        _createElementVNode("span", {
                          onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.togglePasswordVisibility('confirmPassword')))
                        }, [
                          _createElementVNode("img", {
                            class: "pwdIcon",
                            src: _ctx.currentConfirmPassworIcon
                          }, null, 8, _hoisted_27)
                        ])
                      ])
                    ]),
                    _hoisted_28,
                    (_ctx.errorMessage)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_29, _toDisplayString(_ctx.errorMessage), 1))
                      : _createCommentVNode("", true),
                    _createElementVNode("button", {
                      type: "submit",
                      onClick: _cache[5] || (_cache[5] = 
//@ts-ignore
(...args) => (_ctx.pwdUpdate && _ctx.pwdUpdate(...args))),
                      disabled: _ctx.isProcessing
                    }, " パスワード変更 ", 8, _hoisted_30),
                    _createElementVNode("div", _hoisted_31, [
                      _createVNode(_component_router_link, {
                        to: "/login",
                        class: "com_link1 com_fs15 arr1"
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode("ログインページへ戻る")
                        ]),
                        _: 1
                      })
                    ])
                  ])
                ]))
          ])),
      _hoisted_32
    ])
  ]))
}